import { YBUG_DISABLED, YBUG_ID } from 'config'

import { Logger } from '../logger'

const YBUG_SCRIPT_ID = 'ybug-widget-script'

// YBug's own install snippet sets `window.ybug_settings` before loading its loader
// script, which then reads that global itself — there's no npm package to import.
export const initializeYBug = () => {
  try {
    // Turned off on purpose (production): not a misconfiguration, so nothing is logged.
    if (YBUG_DISABLED) return

    if (!YBUG_ID) {
      Logger.error({
        message: 'YBug initialization failed: Missing configuration.',
        payload: { file: 'ybug', method: 'initializeYBug' }
      })

      return
    }

    if (document.getElementById(YBUG_SCRIPT_ID)) return

    // Default YBug branding (vivid violet) reads as loud against this app's own
    // navy/blue palette — match the app's brand blue (--primary, #1F6FEB) instead
    // so the launcher looks native rather than like a bolted-on third-party widget.
    // Custom theme to make it lighter
    window.ybug_settings = {
      id: YBUG_ID,
      primary_color: '#1F6FEB',
      secondary_color: '#FFFFFF',
      dark_primary_color: '#1F6FEB',
      dark_secondary_color: '#FFFFFF',
      launcher_position: 'right-middle'
    }

    const script = document.createElement('script')
    script.id = YBUG_SCRIPT_ID
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://widget.ybug.io/button/${YBUG_ID}.js`
    ;(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script)
  } catch (error) {
    Logger.error({ message: error, payload: { file: 'ybug', method: 'initializeYBug' } })
  }
}
